export default __webpack_public_path__ + "static/media/1.28161be0.png";